/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { AuthService } from "../../../../services";

@Component({
  selector: "app-instamed-details-edit",
  templateUrl: "./instamed-details-edit.component.html"
})
export class InstamedDetailsEditComponent {
  @Input() instamedFormGroup!: FormGroup;
  constructor(private authService: AuthService) {}

  hasFinanceRole(): boolean {
    return this.authService.canUserAccess("FINANCE");
  }

  get terminalIdGroup(): FormGroup {
    return this.instamedFormGroup.controls.terminalInfo as FormGroup;
  }
}
